





















































































































































































































































































































































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Component, Vue } from 'vue-property-decorator';
import store from '@/services/store';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import { variantNameLangSupport } from '@/modules/budget/budgetCorrectHelper';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';
import CBudgetEventGu from '@/modules/budget-request/budget-event/budget-event-gu.vue';
import CBudgetEventAbp from '@/modules/budget-request/budget-event/budget-event-abp.vue';
import CBudgetEventUO from '@/modules/budget-request/budget-event/budget-event-uo.vue';
import CBudgetUnsavedChangesModal from '@/modules/budget-request/budget-event/budget-unsaved-changes-modal.vue';

@Component({
    components: {
        'c-bud-event-gu': CBudgetEventGu,
        'c-bud-event-abp': CBudgetEventAbp,
        'c-bud-event-uo': CBudgetEventUO,
        'c-unsaved-changes-modal': CBudgetUnsavedChangesModal
    },
    // хук объявлен в опциях: registerHooks в проекте не вызывается, в теле класса роутер его не увидит
    async beforeRouteLeave(this: any, to: any, from: any, next: any) {
        next((await this.confirmLeave()).ok);
    }
})
export default class CBudgetEventMain extends Vue {
    private tabIndx = 0;
    private tabIndxSelected = 0;

    private enableGuTab = false;
    private editGuTab = false;
    private enableAbpTab = false;
    private editAbpTab = false;
    private enableUOTab = false;
    private editUOTab = false;

    private typeAgr = 0;

    private yearCount = 1; // период планирования: 1 год или 3 года

    // доступность согласования
    private agrEnabledAccess = false; // доступность внутри вкладки по операциям пользователя

    private busy = false; // активная вкладка занята операцией - кнопки заблокированы

    private dataEditable = false; // активная вкладка построила снимок данных и готова к правке

    // текущие значения фильтра
    private curFilter: any = { curYear: (new Date()).getFullYear(), curRegion: null,  curDataType: null, curVariant: null, curAbp: null, curSubord: null, curGu: null, curProg: null, curSubProg: null, guLst: [], curStatus: null };

    private readonly nameAllObj = { name_ru: 'Все', name_kk: 'Барлығы', name_en: 'All' };

    private budgetLevel: number[] = [];
    private variantEndDate: any = null; // дата окончания вариантов, для ограничения справочников фильтров по датам
    // ----
    private curYear = (new Date()).getFullYear();
    private periodLst: any[] = [];
    private curPeriod: any = null;
    // -----------
    private obl: string | null = null;

    private userWorkPlace: string | null = null;

    private regionBase: any[] = [];
    private curRegion: any | null = null;

    private get getRegion() {
        const result: any[] = [];
        for (const el of this.regionBase) {
            result.push(setNameLang(this.$i18n.locale, el, 'code'));
        }
        if (this.curRegion !== null) { this.curRegion = setNameLang(this.$i18n.locale, this.curRegion, 'code'); }
        return result;
    }

    private async chgRegion() {
        await this.loadActiveVariant();
        this.loadVariants();
    }

    // ------------вид данных-----------
    private dataTypeDictBase: any[] = [];
    private curDataType: any | null = null;

    private get dataTypeDict(): any[] {
        const result: any[] = [];
        for (const el of this.dataTypeDictBase) {
            result.push(setNameLang(this.$i18n.locale, el, 'code'));
        }
        if (this.curDataType !== null) { this.curDataType = setNameLang(this.$i18n.locale, this.curDataType, 'code'); }
        return result;
    }

    private chgDataType() {
        this.loadVariants();
    }

    // ------------- версия бюджета
    private curVariant: null | any = null;
    private variantBase: any[] = [];

    private get variantLst(): any[] {
        const res: any[] = [];
        for (const el of this.variantBase) {
            const tmpObj = setNameLang(this.$i18n.locale, el);
            res.push(tmpObj);
        }
        if (this.curVariant !== null) { this.curVariant = setNameLang(this.$i18n.locale, this.curVariant); }
        return res;
    }

    private async chgCurVariant() {
        await this.getVariantEndDate();
        this.getBudgetLevel()
        // this.chgEvent('watch curVariant');
    }

    // ------------------ администратор программ ------------------
    private abpBase: any[] = [];
    private abpGkkpBase: any[] = [];
    private curAbp: any | null = null;

    private get abp(): any[] {
        const res: any[] = [];
        for (const el of this.abpBase) {
            res.push(setNameLang(this.$i18n.locale, el, 'abp'));
        }
        if (res.length) {
            if (this.tabIndxSelected === 2) {
                res.unshift(setNameLang(this.$i18n.locale, {abp: null, name_ru: 'Все', name_kk: 'Барлығы', name_en: 'All'}));
            } else {
                if (this.curAbp && this.curAbp.abp === null) {
                    this.curAbp = res[0];
                    this.chgAbp();
                }
            }
        }
        if (this.curAbp !== null) {
            if (this.curAbp.abp!==null) {
                this.curAbp = setNameLang(this.$i18n.locale, this.curAbp, 'abp');
            } else {
                this.curAbp = setNameLang(this.$i18n.locale, this.curAbp);
            }
        }
        return res;
    }

    private async chgAbp() {
        if (this.curAbp && !this.curAbp.abp) {
            this.chgEvent('chgAbp');
            return;
        }
        //if (this.tabIndxSelected !== 2 && this.tabIndxSelected !== 1) { await this.chgEvent('watch chgAbp') };
        this.loadSubordinate();
        //this.getFavoriteEnabled();
        //await this.getDictGuForBudgetGkkp();
        //this.fetchSpf();
        this.loadProg();
    }

    // -------------- Подведомственные -----
    private subordBase: any[] = [];
    private curSubord: any | null = null;

    private get subordLst(): any[] {
        const result: any[] = [];
        for (const el of this.subordBase) {
            if (el.code!==null) {
                result.push(setNameLang(this.$i18n.locale, el, 'code'));
            } else {
                result.push(setNameLang(this.$i18n.locale, el));
            }
        }
        if (this.curSubord !== null) {
            let code: string | null = null;
            if (this.curSubord.code !== null) { code ='code' }
            this.curSubord = setNameLang(this.$i18n.locale, this.curSubord, code);
        }
        return result;
    }

    private chgSubord() {
        //if (this.tabIndxSelected === 0 || this.tabIndxSelected === 1) { this.chgEvent('chgSubord'); }
        this.loadGu();
    }

    // --------- гос учреждение ------------
    private guBase: any[] = [];
    private curGu: any | null = null;

    private get gu(): any[] {
        const result: any[] = [];
        let flAll = false; // есть ли Все гу
        for (const el of this.guBase) {
            if (el.code === null) { flAll = true; }
            if (el.code) {
                result.push(setNameLang(this.$i18n.locale, el, 'code'));
            } else {
                result.push(setNameLang(this.$i18n.locale, el));
            }
        }
        if (this.tabIndxSelected === 1 && !flAll && result.length > 0) { result.unshift(setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { code: null }))); }
        result.sort((a, b) => (a.code > b.code) ? 1 : -1);
        if (this.curGu !== null) {
            if (this.tabIndxSelected === 0 && this.curGu.code === null) {
                if (result.length > 0) {
                    this.curGu = setNameLang(this.$i18n.locale, result[0], 'code');
                    this.$nextTick(() => { this.chgGu(); });
                }
            } else {
                let code: string | null = null;
                if (this.curGu.code !== null) { code ='code' }
                this.curGu = setNameLang(this.$i18n.locale, this.curGu, code);
            }
        }
        return result;
    }

    private chgGu() {
        this.chgEvent('chgGu');
    }

    // ------------------------ программа --------------------------
    private progBase: any[] = [];
    private curProg: any | null = null;

    private get prog(): any[] {
        const res: any[] = [];
        for (const el of this.progBase) {
            res.push(setNameLang(this.$i18n.locale, el, 'prg'));
        }
        if ((this.tabIndxSelected === 1 || this.tabIndxSelected === 2) && res.length) {
            const allObj = setNameLang(this.$i18n.locale, {prg: null, name_ru: 'Все', name_kk: 'Барлығы', name_en: 'All'});
            res.unshift(allObj);
        } else {
            if (this.curProg && this.curProg.prg === null) {
                this.curProg = res.length ? res[0] : null;
                this.chgProg();
            }
        }
        if (this.curProg !== null) {
            if (this.curProg.prg === null) {
                this.curProg = setNameLang(this.$i18n.locale, this.curProg);
            } else {
                this.curProg = setNameLang(this.$i18n.locale, this.curProg, 'prg');
            }
        }
        return res;
    }

    private async chgProg() {
    /* if (this.curProg) {
            this.funcGr = this.curProg.gr;
        } else {
            this.funcGr = null;
        }*/
        await this.loadSubProg();
    }

    // ----------------------------подпрограмма------------------------
    private subProgBase: any[] = [];
    private curSubProg: any | null = null;

    private get subProg(): any[] {
        const res: any[] = [];
        for (const el of this.subProgBase) {
            if (el.ppr !== null) {
                res.push(setNameLang(this.$i18n.locale, el, 'ppr'));
            } else {
                res.push(setNameLang(this.$i18n.locale, el));
            }
        }
        if (this.curSubProg !== null) {
            if (this.curSubProg.ppr === null) {
                this.curSubProg = setNameLang(this.$i18n.locale, this.curSubProg);
            } else {
                this.curSubProg = setNameLang(this.$i18n.locale, this.curSubProg, 'ppr');
            }
        }
        return res;
    }
    // --------------------Категории ----

    private categoryBase: any[] = [];
    private curCategory: any | null = null;

    private get allCategory() {
        const res: any[] = [];
        for (const el of this.categoryBase) {
            const tmpObj = setNameLang(this.$i18n.locale, el);
            res.push(tmpObj);
        }
        if (this.curCategory !== null) {
            this.curCategory = setNameLang(this.$i18n.locale, this.curCategory);
        }
        return res;
    }
    // -------------------------Статусы

    private statusBase: any[] = [];
    private curStatus: any | null = null;

    private get statusLst() {
        const res: any[] = [];
        for (const el of this.statusBase) {
            const tmpObj = setNameLang(this.$i18n.locale, el);
            res.push(tmpObj);
        }
        if (this.curStatus !== null) {
            this.curStatus = setNameLang(this.$i18n.locale, this.curStatus);
        }
        return res;
    }


    private mounted() {
        this.loadStatusLst();
        this.loadAllCategory();
        this.loadDataTypeDict();
        this.loadRegion();
        this.getModulesAccess();
        this.loadVariants();
        this.$watch('store.state.user.userModules', () => { this.getModulesAccess(); });
        this.$watch('tabIndx', () => { this.getTabIndx(); });
        // при смене вкладки согласование недоступно, пока новая вкладка не загрузит операции пользователя
        this.$watch('tabIndxSelected', () => { this.agrEnabledAccess = false; });
        this.$watch('usrId', () => {
            if (!this.usrId) { return; }
            this.loadRegion();
            this.loadVariants();
        })
        window.addEventListener('beforeunload', this.onBeforeUnload);
        this.getPeriodLst();

        this.$watch('curPeriod', async () => {
            if (this.curPeriod) {
                this.curYear = this.curPeriod.year;
                await this.loadActiveVariant();
                this.loadVariants();
            }
        }, { immediate: true });
    }

    private beforeDestroy() {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
    }

    //// --------------------------- LOAD ---------------------------------------
    private async loadRegion() {
        try {
            const result = await fetch('/api-py/get-budget-obl/' + store.state._instanceCode);
            if (result.status === 200) {
                const json = await result.json();
                this.obl = json.obl;
            } else {
                makeToast(this, 'danger', 'get-budget-obl', `${result.status} - ${result.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка запроса get-budget-obl', (error as Error).toString());
        }

        if (!this.usrId) { return; }

        try {
            await fetch('/api-py/get-user-regions-by-obl/' + this.obl + '/' + this.usrId)
                .then(response => response.json())
                .then(json => {
                    if (json.length && json[0].code) {
                        json.sort((a: any, b: any) => (a.code - b.code > 0) ? 1 : -1);
                        this.regionBase = json;
                    }

                });
        } catch (error) {
            this.regionBase = [];
            makeToast(this, 'danger', 'Ошибка запроса get-user-budget-region', (error as Error).toString());
        }
        if (this.regionBase.length) {
            this.curRegion = setNameLang(this.$i18n.locale, this.regionBase[0], 'code')
        } else {
            this.curRegion = null;
        }
        this.chgRegion();
    }

    private async loadDataTypeDict() {
        let result: any[] = [];
        try {
            result = await fetch('/api-py/dict_budget_data_types/')
                .then(response => response.json());
        } catch (error) {
            result = [];
            makeToast(this, 'danger', 'Ошибка загрузки вида данных', (error as Error).toString());
        }
        result.sort((a, b) => (a.code > b.code) ? 1 : -1);
        this.dataTypeDictBase = result;
        if (this.dataTypeDictBase.length > 0) {
            let el = null;
            el = this.dataTypeDictBase[0];
            this.curDataType = setNameLang(this.$i18n.locale, el, 'code');
        }
    }

    // ----- закгрузка активного варианта
    private async loadActiveVariant() {
        if (!this.curYear || !this.curRegion) { return; }
        const params = { year: this.curYear, region: this.curRegion.code };
        const url = `/api-py/get--active-variants-for-calcsum/${encodeURI(JSON.stringify(params))}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
                if (response.length) {
                    for (let i = 0; i < this.dataTypeDict.length; i++) {
                        if (response[0].data_type.toString() === this.dataTypeDict[i].code) {
                            this.curDataType = this.dataTypeDict[i];
                            break;
                        }
                    }
                }
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки активных вариантов', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки активных вариантов', (error as Error).toString());
        }
    }

    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }

    private async getPeriodLst() {
        let result: any | null = null;
        try {
            const response: any = await fetch(`/api-py/next-year-relevant-version-exists/${this.usrId}`);
            if (response.status === 200) {
            result = await response.json();
            } else {
                makeToast(this, 'danger', 'next-year-relevant-version-exists', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка запроса next-year-relevant-version-exists', (error as Error).toString());
        }
        const year = result ? result.cur_year: (new Date()).getFullYear();
        const next = result && result.exists ? 1: 0;
        this.periodLst = [];
        for (let i = year - 2020 + next; i > 0; i--) {
            this.periodLst.push({ name: `${2020 + i} - ${2020 + i + 2}`, year: 2020 + i });
        }
        this.curPeriod = { name: `${year + next} - ${year + 2 + next}`, year: year + next };
        this.curYear = this.curPeriod.year;
    }

    private async loadVariants() {
        this.variantBase = [];
        if (!this.curYear || !this.curDataType || !this.curRegion || !this.usrId) { return; }
        const params = { year: this.curYear, dataType: this.curDataType.code, region: this.curRegion.code };
        const url = `/api-py/get-variants-for-calcsum/${encodeURI(JSON.stringify(params))}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
                for (const el of response) {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    el.name_ru = variantNameLangSupport(el, 'ru');
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    el.name_kk = variantNameLangSupport(el, 'kk');
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    el.name_en = variantNameLangSupport(el, 'en');
                }
                this.variantBase = response;
                if (this.variantBase.length) {
                    const tmpObj = this.getFirstActiveVariant();
                    if (!this.curVariant || this.curVariant.variant_uuid!== tmpObj.variant_uuid) {
                        const flNull = (this.curVariant === null);
                        this.curVariant = tmpObj;
                    }
                } else {
                    this.curVariant = null;
                }
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки вариантов', `${response.status} - ${response.statusText}`);
                this.curVariant = null;
            }
        } catch (error) {
            this.curVariant = null;
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки вариантов', (error as Error).toString());
        } finally {
            this.chgCurVariant();
        }
    }

    private getFirstActiveVariant() { // получить первый активный вариант или утверждённый
        let utv: any | null = null; // утверждённый
        let max: any | null = null; // макс id
        for (let i = 0; i < this.variantBase.length; i++) {
            const el = this.variantBase[i];
            if (el.attribute) { return setNameLang(this.$i18n.locale, el); }
            if (max === null) {
                max = el;
            } else if (max.id<el.id) {
                max = el;
            }
            if (el.status) {
                if (utv === null) {
                    utv = el;
                } else {
                    if (el.date_ueb === null  || utv.date_ueb === null) {
                        if (el.id > utv.id)  { utv = el; }
                    } else if (new Date(el.date_ueb) > new Date(utv.date_ueb)){
                        utv = el;
                    }
                }
            }
        }
        if (utv) { return setNameLang(this.$i18n.locale, utv); }
        return max? setNameLang(this.$i18n.locale, max): null;
    }

    private async loadAbp() {
        if (!this.curVariant || !this.budgetLevel || this.budgetLevel.length < 1) {
            this.curAbp = null;
            this.chgAbp();
            return;
        }
        const vers_year = (this.curDataType.code == '2' ? this.curVariant.year: null);
        const params = { region: this.curRegion.code, usrId: this.usrId, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: vers_year, level: this.budgetLevel };
        const url = `/api-py/get-dict-abp-by-level-user-region-dateend/${encodeURI(JSON.stringify(params))}`

        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки адм. программ', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки адм. программ', (error as Error).toString());
        }

        response.sort((a: any, b: any) => (a.abp - b.abp > 0) ? 1 : -1);
        this.abpBase = this.setIdArr(response, 'abp');

        if (this.abpBase.length > 0) {
            let abp: any = null;
            if (this.curAbp) {
                abp = this.findElByCode('abp', this.curAbp.abp, this.abpBase);
            }
            this.curAbp = abp !== null ? abp:  this.abpBase[0];
        } else {
            this.curAbp = null;
        }
        this.chgAbp();
    }

    /**
     * получение variantStartDate для ограничение действия справочников в фильтрах
     */
     private async getVariantEndDate() {
        if (!this.curVariant) {
            this.variantEndDate = null;
            return;
        }
        if (this.curVariant.date_ueb) {
            this.variantEndDate = this.curVariant.date_ueb;
            return;
        }
        if (this.curVariant.attribute === true && this.curVariant.status === false && !this.curVariant.is_deleted) {
            this.variantEndDate = null;
            return;
        }

        let response: any = [];
        try {
            response = await fetch(`/api-py/get-next-variant-date-start/${encodeURI(this.curVariant.date_start)}`);
            if (response.status === 200) {
                response = await response.json();
                this.variantEndDate = response.date;
            } else {
                this.variantEndDate = null;
                makeToast(this, 'danger', 'Ошибка get-next-variant-date-start', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            this.variantEndDate = null;
            makeToast(this, 'danger', 'Ошибка get-next-variant-date-start', (error as Error).toString());
        }
    }

    private async loadSubordinate() {
        this.subordBase = [];
        this.curSubord = null;
        const reducingResult = await this.checkReducingUser();
        if (!reducingResult || !reducingResult.exists) {
            this.chgSubord();
            return;
        } // не является ни сводящим, ни тех поддержкой, ни консом
        let subordLst: any[] = [];
        // когда юзер сводящий отдела ГУ
        if (reducingResult.subord) {
            subordLst = reducingResult.subord;
        } else {
            let response: any = [];
            const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
            const params = { abp: this.curAbp.abp, region: this.curRegion.code, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: versYear };
            try {
                response = await fetch(`/api-py/get-budget-event-subordinate/${encodeURI(JSON.stringify(params))}`);
                if (response.status === 200) {
                    subordLst = await response.json();
                } else {
                    this.variantEndDate = null;
                    makeToast(this, 'danger', 'Ошибка get-budget-event-subordinate', `${response.status} - ${response.statusText}`);
                }
            } catch (error) {
                makeToast(this, 'danger', 'Ошибка get-budget-event-subordinate', (error as Error).toString());
            }
        }
        if (subordLst.length) {
            subordLst.sort((a: any, b: any) => (a.code > b.code) ? 1 : -1);
            subordLst.unshift({code: null, name_ru: 'Все', name_kk: 'Барлығы'});
            this.subordBase = subordLst;
            this.curSubord = setNameLang(this.$i18n.locale, subordLst[1], 'code');
        }
        this.chgSubord();
    }

    // проверка на должность сводящего или техподдержки (для сводящего отдела сразу получает список по отделу в subord)
    private async checkReducingUser() {
        let response: any = [];
        this.userWorkPlace = null;
        const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
        const params = { region: this.curRegion.code, abp: this.curAbp.abp, usrId: this.usrId, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: versYear };
        try {
            response = await fetch(`/api-py/subord-user-reducing-position/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                response = await response.json();
                this.userWorkPlace = response.type? response.type: null;
                return response;
            } else {
                this.variantEndDate = null;
                makeToast(this, 'danger', 'Ошибка subord-user-reducing-position', `${response.status} - ${response.statusText}`);
                return null;
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка subord-user-reducing-position', (error as Error).toString());
            return null;
        }
    }

    private async loadGu() {
        this.guBase = [];
        this.curGu = null;
        const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
        const params = { region: this.curRegion.code, abp: this.curAbp.abp, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: versYear, subord: this.curSubord? this.curSubord.code: null, userId: this.usrId };
        let url = '/api-py/get-budget-event-gu-not-reducing'; // копда пользователь не сводящий и не тех поддержка
        // сводящий в головном ГУ или тех поддержка с консом
        if (this.userWorkPlace == 'headOffice' || this.userWorkPlace == 'support') {
            url = '/api-py/get-budget-event-gu-for-headoffice';
        } else if (this.userWorkPlace == 'department') { // сводящий в отделе
            url = '/api-py/get-budget-event-gu-for-department';
        }

        try {
            const response = await fetch(`${url}/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                const result = await response.json();
                result.sort((a: any, b: any) => (a.code > b.code) ? 1 : -1);
                if (result.length > 0) {
                    this.curGu = setNameLang(this.$i18n.locale,  result[0]);
                }
                this.guBase = result;
            } else {
                this.variantEndDate = null;
                makeToast(this, 'danger', 'Ошибка get-budget-event-gu-for-headoffice', `${response.status} - ${response.statusText}`);

            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-event-gu-for-headoffice', (error as Error).toString());
        } finally {
            this.chgGu();
        }
    }

    /**
     * загрузка Программ
     */
     private async loadProg() {
        if (!this.curAbp) {
            this.curProg = null;
            return;
        }
        let response: any = [];
        this.progBase = [];
        const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
        const params = { abp: this.curAbp.abp, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: versYear };
        try {
            response = await fetch(`/api-py/get-dict-func-prog-subprog/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                response = await response.json();
            } else {
                response = [];
                makeToast(this, 'danger', 'Ошибка загрузки программ', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки программ', (error as Error).toString());
        }

        response.sort((a: any, b: any) => (a.prg - b.prg > 0) ? 1 : -1);
        this.progBase = this.setIdArr(response, 'prg');

        if (this.progBase.length > 0) {
            this.curProg = setNameLang(this.$i18n.locale,  this.progBase[0], 'prg');
        } else {
            this.curProg = null;
        }
        await this.chgProg();
    }

    private async loadSubProg() {
        let response: any = [];
        this.subProgBase = [];
        this.curSubProg = null;
        if (this.curProg !== null) {
            const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
            const params = { abp: this.curAbp.abp, date_b: this.curVariant.date_start, date_e: this.variantEndDate, prg: this.curProg.prg, vers_year: versYear };
            let url = '/api-py/get-dict-func-prog-subprog';
            if (this.curProg.prg === null) { url = '/api-py/get-dict-func-all-subprog-by-abp'; }
            try {
                response = await fetch(`${url}/${encodeURI(JSON.stringify(params))}`);
                if (response.status === 200) {
                    response = await response.json();
                } else {
                    response = [];
                    makeToast(this, 'danger', 'Ошибка загрузки подпрограмм', `${response.status} - ${response.statusText}`);
                }
            } catch (error) {
                makeToast(this, 'danger', 'Ошибка загрузки подпрограмм', (error as Error).toString());
                response = [];
            }
        }

        response.sort((a: any, b: any) => (a.ppr - b.ppr > 0) ? 1 : -1);
        if (response.length && this.curProg.prg === null) { response.unshift({ppr: null, name_ru: 'Все', name_kk: 'Барлығы'}); }

        if (response.length > 0) {
            this.curSubProg = response[0];
        } else {
            this.curSubProg = null;
        }
        // this.subProgBase = this.setIdArr(response, 'ppr');
        this.subProgBase = response;

        this.chgEvent('loadSubProg');
    }

    private async loadStatusLst() {
        this.statusBase = [];
        try {
            const result = await fetch('api-py/get-budget-event-agreement-status');
            if (result.status === 200) {
                const json = await result.json();
                if (json.length) {
                    json.unshift({name_ru: 'Все', name_kk: 'Барлығы', name_en: 'All', code: null});
                    this.curStatus = setNameLang(this.$i18n.locale,  json[0]);
                }
                this.statusBase = json;
            } else {
                makeToast(this, 'danger', 'get-budget-event-agreement-status', `${result.status} - ${result.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка запроса get-budget-event-agreement-status', (error as Error).toString());
        }
    }

    private async loadAllCategory() {
        try {
            const result = await fetch('api-py/get-dict-events-category/');
            if (result.status === 200) {
                const json = await result.json();
                if (json.length) {
                    json.unshift({name_ru: 'Все', name_kk: 'Барлығы', name_en: 'All', code: null});
                    this.curCategory = setNameLang(this.$i18n.locale,  json[0]);
                    this.categoryBase = json;
                }
            } else {
                makeToast(this, 'danger', 'get-dict-events-category', `${result.status} - ${result.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка запроса get-dict-events-category', (error as Error).toString());
        }
    }

    // -----------------------------------------------------------------------------------------

    private findElByCode(codeName: string, code: any, arr: any[]): any {
        for (const el of arr) {
            if (el[codeName] === code) {
                return el;
            }
        }
        return null;
    }

    private setIdArr(arr: any[], codeName: string) {
        const result: any[] = [];
        for (const el of arr) {
            if (result.length > 0 && el[codeName] === result[result.length - 1][codeName]) {
                result[result.length - 1].idArr.push(el.id);
            } else {
                result.push(Object.assign({ idArr: [el.id] }, el));
            }
        }
        return result;
    }

    private getBudgetLevel() {
        this.budgetLevel = [];
        if (this.curRegion) {
            if (this.curRegion.code.slice(this.curRegion.code.length - 4) === '0101') {
                this.budgetLevel.push(2);
            } else if (this.curRegion.code.slice(this.curRegion.code.length - 2) === '01')  {
                this.budgetLevel.push(3);
            } else if (this.curRegion.code.slice(this.curRegion.code.length - 2) !== '00') {
                this.budgetLevel.push(4);
            }
        }
        this.abpBase = [];
        this.loadAbp();
    }

    private getModulesAccess() {
        // ---
        let access = this.getAccess('004.010.001');
        this.editGuTab = access.editable;
        this.enableGuTab = access.enable;
        // --
        access = this.getAccess('004.010.002');
        this.editAbpTab = access.editable;
        this.enableAbpTab = access.enable;
        // --
        access = this.getAccess('004.010.003');
        this.editUOTab = access.editable;
        this.enableUOTab = access.enable;
        this.getTabIndx();
    }

    private getAccess(code: string) {
        const modules: any[] = store.state.user.userModules;
        let editable = false;
        let enable = false;
        for (const row of modules) {
            if (row.modules === code) {
                if (row.access_level !== 1) {
                    editable = true;
                }
                if ([1, 2, 3].includes(row.access_level)) {
                    enable = true;
                }
            }
        }
        return { editable, enable };
    }

    private getTabIndx() {
        const oldTabIndxSelected = this.tabIndxSelected;
        const arr = [{name: 'gu', indx: 0}, {name: 'abp', indx: 1}, {name: 'uo', indx: 2}];
        for (let i = 0; i < arr.length; i++) {
            if (i < 0) { break; }
            if (!this.enableGuTab && arr[i].name === 'gu') {
                arr.splice(i, 1);
                i--;
            } else if (!this.enableAbpTab && arr[i].name === 'abp') {
                arr.splice(i, 1);
                i--;
            } else if (!this.enableUOTab && arr[i].name === 'uo') {
                arr.splice(i, 1);
                i--;
            }
        }
        if (this.tabIndx < 0) {
            this.tabIndxSelected = this.tabIndx;
        } else {
            this.tabIndxSelected = arr[this.tabIndx].indx;
        }
    }


    private async onActivateTab(newIndex: number, oldIndex: number, bvEvent: any) {
        // у вкладки без flushAndCheck переход свободный
        const tab = this.getDirtyTab();
        if (!tab || !tab.flushAndCheck()) {
            this.busy = false;
            this.dataEditable = false;
            this.tabIndx = newIndex;
            return;
        }

        // синхронно, до первого await: иначе b-tabs уже переключит вкладку
        bvEvent.preventDefault();
        if (!(await this.confirmLeave()).ok) { return; }
        // вкладка уничтожается и сам эти флаги уже не снимет
        this.busy = false;
        this.dataEditable = false;
        this.tabIndx = newIndex;
    }

    /**
     * активная вкладка, если она умеет проверять несохранённые изменения; иначе переход свободный
     */
    private getDirtyTab(): any {
        const refs: any = this.$refs;
        const tab = [refs.refGu, refs.refAbp, refs.refUo][this.tabIndxSelected];
        return tab && typeof tab.flushAndCheck === 'function' ? tab : null;
    }

    /**
     * проверка перед уходом со вкладки, из раздела или перед сменой фильтра
     * @returns ok - можно уходить; failed - остаёмся, потому что "Сохранить" не удалось (причина уже на экране)
     */
    private async confirmLeave(): Promise<{ ok: boolean; failed: boolean }> {
        const tab = this.getDirtyTab();
        if (!tab || !tab.flushAndCheck()) { return { ok: true, failed: false }; }
        const modal: any = this.$refs.unsavedModal;
        const choice = await modal.open(() => tab.saveBeforeLeave());
        if (choice === 'cancel') { return { ok: false, failed: false }; }
        if (choice === 'failed') { return { ok: false, failed: true }; }
        // после сохранения снимок совпадает с данными, после отказа его нет - повторный activate-tab
        // от программной смены tabIndx пройдёт без модалки: flushAndCheck вкладки вернёт false
        if (choice === 'discard') { tab.discardChanges(); }
        return { ok: true, failed: false };
    }

    /**
     * смена значения в фильтре: присваиваем только после подтверждения,
     * пока значение не присвоено, в поле остаётся прежнее (multiselect своего значения не хранит)
     * @param field поле фильтра
     * @param value выбранное значение
     * @param after обработчик смены, который раньше был в @input
     */
    private async guardFilter(field: string, value: any, after?: () => void) {
        const tab = this.getDirtyTab();
        const wasDirty = !!tab && tab.flushAndCheck(); // покажется ли модалка
        const { ok, failed } = await this.confirmLeave(); // при "Сохранить" ждёт ответа сервера
        if (ok) {
            (this as any)[field] = value;
            if (after) { after(); }
        }
        // модалка забрала фокус и закрыла панель: возвращаем пользователя туда, где он был;
        // при неудачном сохранении поверх стоит окно причины (тост или отклонённые строки): панель была бы тут же закрыта
        if (wasDirty && !failed) {
            const drop: any = this.$refs.drop;
            drop.show();
        }
    }

    /**
     * обновление и закрытие вкладки браузера: стандартное окно браузера, текст в нём задать нельзя
     */
    private onBeforeUnload(e: BeforeUnloadEvent) {
        // через flushAndCheck: при F5 фокус из поля не уходит и признак мог не обновиться
        const tab = this.getDirtyTab();
        if (tab && tab.flushAndCheck()) {
            e.preventDefault();
            e.returnValue = '';
        }
    }

    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.drop;
        drop.show(true);
        const refItem: any = this.$refs[refName];
        setTimeout(() => refItem.$el.focus(), 100);
    }

    private chgEvent(source: string) {
        if (source === 'loadSubProg') {
            const progFl = (this.curProg === this.curFilter.curProg && this.curProg === null) || (this.curProg !== null && this.curFilter.curProg !== null && this.curProg.prg === this.curFilter.curProg.prg);
            const subProgFl = (this.curSubProg === this.curFilter.curSubProg && this.curSubProg === null) || (this.curSubProg !== null && this.curFilter.curSubProg !== null && this.curSubProg.ppr === this.curFilter.curSubProg.ppr);
            if (progFl && subProgFl) {
                return;
            }
        }
        if (source == 'category' && this.tabIndxSelected !== 2) { return; }
        // --- если выбрано Все ГУ
        let guLst: any[] | null = null;
        if (this.curGu && this.curGu.code === null) {
            guLst = [];
            for (const el of this.gu) {
                if (el.code !== null) { guLst.push(el); }
            }
        }
        // ---

        const params = { curYear: this.curYear, curAbp: this.curAbp, curDataType: this.curDataType, curRegion: this.curRegion, curVariant: this.curVariant, curGu: this.curGu, variantEndDate: this.variantEndDate, curProg: this.curProg, curSubProg: this.curSubProg, guLst: guLst, category: this.curCategory, curStatus: this.curStatus };

        this.curFilter = JSON.parse(JSON.stringify({ curYear: this.curYear, curRegion: this.curRegion,  curDataType: this.curDataType, curVariant: this.curVariant, curAbp: this.curAbp, curSubord: this.curSubord, curGu: this.curGu, curProg: this.curProg, curSubProg: this.curSubProg, variantEndDate: this.variantEndDate, category: this.curCategory, guLst: guLst, curStatus: this.curStatus }));
        if (this.tabIndxSelected == 0) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refGu.chgEvent(params);
        } else if (this.tabIndxSelected == 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refAbp.chgEvent(params);
        } else if (this.tabIndxSelected == 2) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refUo.chgEvent(params);
        }
    }

    /**
     * переключение периода планирования (1 год / 3 года) - данные не перезагружаются,
     * активной вкладке передаётся только новое значение
     */
    private chgYearCount(value: number) {
        this.yearCount = value;
        if (this.tabIndxSelected === 0) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refGu.chgYearCount(value);
        } else if (this.tabIndxSelected === 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refAbp.chgYearCount(value);
        } else if (this.tabIndxSelected === 2) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refUo.chgYearCount(value);
        }
    }

    private chgTypeAgr() {
        if (this.tabIndxSelected == 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refAbp.chgTypeAgr(this.typeAgr);
        }
    }

    private saveClk() {
        if (this.busy) { return; }
        if (this.tabIndxSelected === 0) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refGu.saveClk();
        } else if (this.tabIndxSelected === 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refAbp.saveClk();
        } else if (this.tabIndxSelected == 2) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refUo.saveClk();
        }
    }

    private copyGuDataClk() {
        if (this.tabIndxSelected === 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refAbp.copyGuDataClk();
        }
    }

    private copyAbpDataClk() {
        if (this.tabIndxSelected === 2) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refUo.copyAbpDataClk();
        }
    }

    private chgAgrAccess(agrEnabledAccess: boolean) {
        this.agrEnabledAccess = agrEnabledAccess;
    }

    private chgBusy(busy: boolean) {
        this.busy = busy;
    }

    private chgEditable(editable: boolean) {
        this.dataEditable = editable;
    }

    private agreementEvent() {
        if (this.busy) { return; }
        if (this.tabIndxSelected === 0) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refGu.agreementEvent();
        } else if (this.tabIndxSelected === 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refAbp.agreementEvent();
        }  else if (this.tabIndxSelected === 2) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refUo.agreementEvent();
        }
    }

    // ---- отчёт
    private loadUoReportWrapper() {
        if (!this.curAbp || !this.curDataType || !this.curRegion || !this.curVariant || !this.curCategory) { return; }
        const versYear = (this.curDataType.code == '2') ? this.curVariant.year : null;
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, category: this.curCategory.code, locale: this.$i18n.locale, vers_year: versYear, date_b: this.curVariant.date_start, date_e: this.variantEndDate };
        this.loadReport(params, '/api-py/get-budget-events-total-report');
    }

    private loadAbpReportWrapper() {
        if (!this.curAbp || !this.curDataType || !this.curRegion || !this.curVariant) { return; }
        const versYear = (this.curDataType.code == '2') ? this.curVariant.year : null;
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, locale: this.$i18n.locale, vers_year: versYear, date_b: this.curVariant.date_start, date_e: this.variantEndDate };
        this.loadReport(params, '/api-py/get-budget-events-abp-report');
    }

    private async loadReport(params: any, url: string) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(params)
            });
            if (!response.ok) {
                const errText = await response.text();
                makeToast(this, 'danger', `Ошибка ${url}`, errText.substring(0, 300));
                return;
            }
            const blob = await response.blob();

            // Извлекаем имя файла из заголовка Content-Disposition
            let filename = 'budget_events_report.xls'; // значение по умолчанию
            const contentDisposition = response.headers.get('Content-Disposition');
            if (contentDisposition) {
                // Сначала пытаемся извлечь filename* (UTF-8 кодированное)
                const filenameUtf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
                if (filenameUtf8Match && filenameUtf8Match[1]) {
                    filename = decodeURIComponent(filenameUtf8Match[1]);
                } else {
                    // Если нет filename*, пытаемся извлечь обычный filename
                    const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/i);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1];
                    }
                }
            }

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        } catch (error) {
            makeToast(this, 'danger', `Ошибка ${url}`, (error as Error).toString());
        }
    }

    // скачивание инструкции текущей вкладки на языке интерфейса
    private async downloadInstruction() {
        const info = this.infoTitle;
        if (!info) { return; }
        const infoId = this.$i18n.locale === 'kk' ? info.infoIdKk : info.infoIdRu;
        try {
            const response = await fetch('/api-py/get-info/' + infoId, { method: 'POST' });
            if (!response.ok) {
                makeToast(this, 'danger', 'get-info', `${response.status} - ${response.statusText}`);
                return;
            }
            const url = window.URL.createObjectURL(await response.blob());
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${info.infoBtn} - ${info.subTitle}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            makeToast(this, 'danger', 'get-info', (error as Error).toString());
        }
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    // подсказка и инструкция по вкладкам: 0 - «Заявки ГУ» (45/46), 1 - «Заявки АБП» (51/52), 2 - «Свод УО» (47/48); id - ключи /api-py/get-info
    private get infoTitle() {
        const cfg: Record<number, { key: string; itemCnt: number; infoIdRu: number; infoIdKk: number }> = {
            0: { key: 'info-gu', itemCnt: 3, infoIdRu: 45, infoIdKk: 46 },
            1: { key: 'info-abp', itemCnt: 4, infoIdRu: 51, infoIdKk: 52 },
            2: { key: 'info-uo', itemCnt: 4, infoIdRu: 47, infoIdKk: 48 }
        };
        const tab = cfg[this.tabIndxSelected];
        if (!tab) { return null; }
        const base = `budget-event.${tab.key}.`;
        const items: string[] = [];
        for (let i = 1; i <= tab.itemCnt; i++) { items.push(this.getBudgetText(`${base}item${i}`)); }
        return {
            infoIdRu: tab.infoIdRu,
            infoIdKk: tab.infoIdKk,
            infoBtn: this.getBudgetText(`${base}infoBtn`), // Режим «Мероприятия»
            title: this.getBudgetText(`${base}title`), // Режим «Мероприятия»
            subTitle: this.getBudgetText(`${base}subTitle`), // Раздел «Заявки ГУ» / «Заявки АБП» / «Свод УО»
            text: this.getBudgetText(`${base}text`), // Настоящий раздел предназначен для ...
            listTitle: this.getBudgetText(`${base}listTitle`), // В разделе выполняется:
            items
        };
    }

    private get buttonTitle() {
        const obj = {
            agrEvent: this.getBudgetText('button.agr_event'), // Действия
            download: this.getBudgetText('button.download'), // Скачать
            copyAbp: this.getBudgetText('budget-event.copy-abp.button'), // Копировать с АБП
        }
        return obj
    }

    private get tabTitle() {
        const obj = {
            abp: this.getBudgetText('sum_calc_abp.title'), // Свод по АБП
            gu: this.getBudgetText('sum_calc_gu.title'), // Свод по ГУ
            gkkp: this.getBudgetText('sum_calc_gkkp.title'), // Свод по ГККП
            upload: this.getBudgetText('sum_calc_upload.title') // Пакетная выгрузка
        }
        return obj
    }

    private get otherTitle() {
        const obj = {
            mainTitle: this.getBudgetText('other.mainTitle'), // Бюджетное планирование
        }
        return obj;
    }

    private get filterTitle() {
        const obj = {
            title: this.getBudgetText('filter.filter'), // Фильтр
            filterPrm: this.getBudgetText('filter.params'), // Параметры фильтра
            curYear: this.getBudgetText('filter.curYear'), // Плановый период
            region: this.getBudgetText('filter.region'), // Регион
            dataType: this.getBudgetText('filter.dataType'), // Вид данных
            variant: this.getBudgetText('filter.variant'), // Версия бюджета
            abp: this.getBudgetText('filter.abp'), // Адм. программ
            subord: this.getBudgetText('filter.subord'), // Подведомственные
            gu: this.getBudgetText('filter.gu'), // Гос. учреждение
            prg: this.getBudgetText('filter.prg'), // Программа
            subprog: this.getBudgetText('filter.subprog'), // Подпрограмма

            yearCount: {
                "title": this.getBudgetText('filter.yearCount.title'), // Показать
                "val1": this.getBudgetText('filter.yearCount.val1'), // 1 год
                "val3": this.getBudgetText('filter.yearCount.val3') // 3 года
            },

            bread: {
                "val0": this.getBudgetText('filter.bread.val0'), //  -регион
                "val1": this.getBudgetText('filter.bread.val1'), //  -версия
                "val2": this.getBudgetText('filter.bread.val2'), //  -АБП
                "val3": this.getBudgetText('filter.bread.val3'), //  ВСЕ-ГУ
                "bp": this.getBudgetText('sum_calc_upload.bp'), //  БП
                "bpp": this.getBudgetText('sum_calc_edit.bpp') //  БПП
            }
        }
        return obj;
    }
}
